import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import React from 'react';

import TimeUnits from '@swf/components/TimeUnits/TimeUnits';

export interface Props {
  time: { endTime: number; startTime: number };
}

const Duration: React.FC<Props> = ({ time }) => {
  const { startTime, endTime } = time;
  const days = differenceInDays(endTime, startTime);
  const hours = differenceInHours(endTime, startTime);
  const minutes = differenceInMinutes(endTime, startTime);

  if (hours > 24) {
    return <TimeUnits days={days} />;
  }
  if (minutes > 60) {
    return <TimeUnits hours={hours} />;
  }
  return <TimeUnits minutes={minutes} />;
};

export default Duration;
